import { AlertApi, AnchorWatchApi, ApiClient, CurrentLogApi, DepthWatchApi, IAlertCommandRequest, IAnchorWatchRequest, IAppResponse, IDepthWatchRequest, IEngineHintRequest, ILogLighting, ILogResponse, IManualShipStatusRequest, ManualShipStatusApi } from "../../Types"

// Shared runtime for the UserAdvice dialog children: the anchor-monitor and stop
// views both POST through these current-log helpers. Kept in one module (re-exported
// by the UserAdviceViews barrel) so the .Data test keeps a single wire-contract seam.
export const UserAdviceViewsData = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
  log(api: ApiClient, values: any): Promise<ILogResponse> {
    return new CurrentLogApi(api).current.log({ params: {}, body: values }).call();
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
  stop(api: ApiClient, values: any): Promise<ILogResponse> {
    return new CurrentLogApi(api).current.stop({ params: {}, body: values }).call();
  },
  lighting(api: ApiClient, lighting: ILogLighting): Promise<ILogResponse> {
    return new CurrentLogApi(api).current.lighting({ params: {}, body: { lighting } }).call();
  },
  // The crew's answer to the engine-missing hint (#1227). Deliberately the *only* write
  // path for that hint: the client never composes engine or status writes itself, so two
  // devices answering the same hint cannot race into a contradictory logbook. The primary
  // re-runs the detection before acting and is a no-op once the hint is resolved.
  engineHint(api: ApiClient, values: IEngineHintRequest): Promise<IAppResponse> {
    return new CurrentLogApi(api).current.engineHint({ params: {}, body: values }).call();
  },
  // Enable / disable, reconfigure, or recenter the anchor watch through the
  // dedicated lifecycle route. The swing-circle origin is seeded server-side from
  // the current fix, so the request never carries a position.
  anchorWatch(api: ApiClient, values: IAnchorWatchRequest): Promise<IAppResponse> {
    return new AnchorWatchApi(api).anchorWatch.update({ params: {}, body: values }).call();
  },
  // Enable / disable the standalone underway depth watch (#990) through its own
  // lifecycle route. No method/geometry to seed -- unlike the anchor watch, depth
  // alerting always uses the ship-wide default threshold.
  depthWatch(api: ApiClient, values: IDepthWatchRequest): Promise<IAppResponse> {
    return new DepthWatchApi(api).depthWatch.update({ params: {}, body: values }).call();
  },
  // Issue a snooze / acknowledge / clear command against an open alert.
  alertCommand(api: ApiClient, alertName: string, values: IAlertCommandRequest): Promise<IAppResponse> {
    return new AlertApi(api).alert.update({ params: { alertName }, body: values }).call();
  },
  // Start, extend or end the manual ship-status mode (#511) through its own
  // lifecycle route. `enabled: true` on an already-running mode EXTENDS it -- the
  // server rewrites the open status's `expiresAt` in place -- so the dialog's extend
  // and the LogButton's switch-on are the same request.
  manualShipStatus(api: ApiClient, values: IManualShipStatusRequest): Promise<IAppResponse> {
    return new ManualShipStatusApi(api).manualShipStatus.update({ params: {}, body: values }).call();
  },
};
